// @flow

import type {ApplicationState} from '../../types'
import type {MapState} from '../types'

export function getApiIndex(appState: ApplicationState): ?ApiIndex<MapApi>{
  return _getApiIndex(appState.map) 
}

function _getApiIndex(state: MapState): ?ApiIndex<MapApi> {
  return state.apiIndex
}

getApiIndex.internal = _getApiIndex
